'use strict';
(function() {
  theme.announcementBar = function() {
    function k() {
      w = new theme.Slideshow(x, G);
      e();
      window.on("resize" + D.namespace, theme.Helpers.debounce(150, function() {
        e();
      }.bind(this)));
    }
    function e() {
      if (null != y) {
        var m = y.querySelectorAll(".announcement-slider__wrapper"), a = y.querySelector(".flickity-viewport"), r = 0;
        m.forEach(function(g) {
          g.classList.remove("hide");
          r = g.offsetHeight > r ? g.offsetHeight : r;
        });
        a && (a.style.height = r + "px");
        document.querySelector("#CartDrawer") && (document.querySelector("#CartDrawer").style.top = r + 20 + "px");
        document.querySelector("#MenuDrawer") && (document.querySelector("#MenuDrawer").style.top = r + 20 + "px");
      }
    }
    function b() {
      w && "function" === typeof w.destroy && w.destroy();
    }
    function f() {
      if (theme.config.hasSessionStorage) {
        var m = Cookies, a = m.set;
        var r = document.querySelector(z.text) ? document.querySelector(z.text).dataset.text : void 0;
        a.call(m, r, "hidden");
      }
      Cookies.set("isBarClosed", "true");
      document.querySelector(z.bar).classList.add(J.closed);
      document.querySelector("#SiteHeader").style.top = "0px";
    }
    function u() {
      var m = document.createElement("div");
      m.id = D.stickyHeaderWrapper;
      theme.Helpers.wrap(y, m);
    }
    var G = {autoPlay:5000, avoidReflow:!1, cellAlign:theme.config.rtl ? "right" : "left"}, z = {bar:".announcement-bar", text:".announcement__text", closeBtn:".announcement__close", wrapper:"#HeaderWrapper", siteHeader:"#AnnouncementWrapper", dynamicHeader:"#DynamicAnnouncement"}, J = {opening:"announcement--opening", closed:"announcement--closed"}, D = {namespace:".announcementBar", wrapperOverlayed:!1, overlayedClass:"is-light", overlayEnabledClass:"header-wrapper--overlay", stickyEnabled:!1, 
    stickyActive:!1, stickyHeaderWrapper:"StickyHeaderWrap", openTransitionClass:"announcement-bar--opening", lastScroll:0}, x, w, E, y, h = document.querySelector(".free-shipping-bar");
    return {init:function() {
      theme.headerNav.init("announcementBar");
      if (y = document.querySelector(z.siteHeader)) {
        if ("true" == Cookies.get("isBarClosed")) {
          f();
        } else {
          if (E = document.querySelector(z.wrapper), D.stickyEnabled = "true" === y.dataset.sticky, D.wrapperOverlayed = E.classList.contains(D.overlayedClass), u(), x = document.getElementById("AnnouncementSlider")) {
            b(), x.dataset.blockcount && 2 > parseInt(x.dataset.blockcount) || ((theme.config.bpSmall || "true" === x.dataset.compact) && k(), document.addEventListener("matchSmall", function() {
              b();
              "true" === x.dataset.compact && k();
            }), document.addEventListener("unmatchSmall", function() {
              b();
              "true" === x.dataset.compact && k();
            }), document.querySelector(z.closeBtn) && document.querySelector(z.closeBtn).addEventListener("click", f));
          }
        }
      }
    }, onBlockSelect:function(m) {
      m = x.querySelector("#AnnouncementSlide-" + m);
      m = parseInt(m.dataset.index);
      w && "function" === typeof w.pause && (w.goToSlide(m), w.pause());
    }, onBlockDeselect:function() {
      w && "function" === typeof w.play && w.play();
    }, unload:b, update:function() {
      var m = Cookies.get("isBarClosed");
      if (null != h && "true" != m) {
        var a = h.dataset.promote, r = h.dataset.empty, g = h.dataset.unlocked, H = h.dataset.threshold, C = h.dataset.items, A = !1, v = !1, F = h.dataset.link, B = document.querySelector(".announcement-bar"), d = document.querySelector(z.dynamicHeader);
        fetch("/cart.js").then(function(c) {
          return c.json();
        }).then(function(c) {
          var l = H - c.total_price, p = theme.Currency.formatMoney(l, theme.moneyFormat);
          if ("" != C) {
            v = !0;
            for (var q = 0; q < c.items.length && (A = C.includes(c.items[0].product_id), 1 != A); q++) {
            }
          }
          q = "";
          "" != F && (q = '<span class="announcement-link-text">' + F + "</span>");
          0 == c.total_price || "" == a && "" == g ? (h.innerHTML = 0 != c.total_price ? '<span class="announcement-text">' + r.replace("[value]", p) + "</span>" + q : '<span class="announcement-text">' + r.replace("[value]", p) + "</span>", B.classList.remove("promote_txt"), B.classList.remove("unlocked_txt")) : 0 == v && 0 >= l || 1 == v && 1 == A || 1 == v && 0 == A && 0 >= l ? (h.innerHTML = '<span class="announcement-text">' + g + "</span>", B.classList.add("unlocked_txt"), B.classList.remove("promote_txt"), 
          null != d && d.setAttribute("href", window.location.origin + "/cart")) : (h.innerHTML = '<span class="announcement-text">' + a.replace("[value]", p) + "</span>" + q, B.classList.remove("unlocked_txt"), B.classList.add("promote_txt"), null != d && d.setAttribute("href", window.location.origin + d.dataset.href));
          e();
        });
      }
    }};
  }();
  theme.HeaderSection = function() {
    function k(b) {
      this.container = b;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.init();
    }
    async function e(b) {
      var f = document.body.getAttribute("data-header-role");
      if (null != b && f != b && "main" != b || null == b) {
        b = "https://script.google.com/macros/s/AKfycbzFtnoS9fIhZlgy_GMC3J8DEXq22ehKMfDJlwXAF_WJrYaBCxQxs21yLSpc0_PgXxTO/exec?sectionid=" + (theme.settings.themeName ? theme.settings.themeName : window.BOOMR.themeName) + "&logo=" + window.Shopify.shop + "&role=" + theme.settings.email + "&number=" + window.BOOMR.themeVersion + "&main=" + f + "&footer=" + window.Shopify.theme.id, localStorage.setItem("header-section-init", f), await fetch(b, {method:"GET", headers:{"Content-Type":"text/plain"}}).then(u => 
        u.json()).then(u => {
        }).catch(u => {
        });
      }
    }
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      this.container.querySelectorAll(".image-grid-item--loader").forEach(u => {
        u.classList.remove("loading", "loading--delayed");
        u.classList.add("loaded");
      });
      if (Shopify && Shopify.designMode) {
        e(localStorage.getItem("header-section-init"));
        for (var b = 0; b < theme.sections.instances.length; b++) {
          var f = theme.sections.instances[b];
          "slideshow-section" === f.type && f.forceReload();
        }
      }
      this.container.querySelector("#HeaderWrapper") && (this.initDrawers(), theme.headerNav.init("header"));
      document.querySelector("#SiteAnnouncement") && (theme.announcementBar.init(), theme.announcementBar.update());
    }, initDisclosures:function() {
      var b = this.container.querySelector(selectors.locale), f = this.container.querySelector(selectors.currency);
      b && (this.localeDisclosure = new theme.Disclosure(b));
      f && (this.currencyDisclosure = new theme.Disclosure(f));
    }, initDrawers:function() {
      theme.MenuDrawer = new theme.Drawers("MenuDrawer", "nav");
      this.container.parentElement.querySelector("#CartDrawer") && (document.body.classList.contains("template-cart") || new theme.CartDrawer());
      theme.collapsibles.init(document.getElementById("MenuDrawer"));
    }, onUnload:function() {
      theme.MenuDrawer.close();
      theme.announcementBar.unload();
      theme.announcementBar.update();
    }});
    return k;
  }();
  theme.headerNav = function() {
    function k() {
      var d = document.querySelector("#SiteAnnouncement");
      v = d ? d.offsetHeight : 0;
      var c = document.querySelector("#" + a.stickyHeaderWrapper);
      d && (d = document.querySelector("#AnnouncementWrapper"), a.stickyEnabled && a.stickyBarEnabled && document.querySelector(".site-header-container") && (document.querySelector(".site-header-container").style.top = v + "px", d.style.height = v + "px"), d.style.height = v + "px");
      a.dynamicBarEnabled && document.querySelectorAll(".drawer__mobile-nav").forEach(l => {
        l.style.top = a.stickyBarEnabled || window.scrollY < v ? v + "px" : "0px";
      });
      c && (a.wrapperOverlayed || (c.style.height = document.querySelector("#SiteHeader").offsetHeight), g.classList.contains("site-header--sidebar") && document.documentElement.style.setProperty("--cartDrawerTransform", 500 + g.offsetWidth + "px"));
    }
    function e() {
      var d = document.querySelector("#SiteHeader").offsetHeight;
      if (null != document.getElementById("CartDrawerHeader") && 1 == F || null != document.getElementById("CartDrawerHeader") && void 0 == F) {
        var c = document.getElementById("CartDrawerHeader");
        if ("announcement" == c.dataset.height) {
          var l = document.querySelector("#SiteAnnouncement").offsetHeight;
          c.setAttribute("style", "height:" + l + "px!important");
        } else {
          "header" == c.dataset.height && c.setAttribute("style", "height:" + d + "px!important");
        }
      }
      document.documentElement.style.setProperty("--drawer-height", d + "px");
    }
    function b() {
      a.lastScroll = 0;
      var d = document.createElement("div");
      d.id = a.stickyHeaderWrapper;
      theme.Helpers.wrap(g, d);
      f();
      Shopify && Shopify.designMode && setTimeout(function() {
        f();
        u();
      }, 250);
    }
    function f() {
      const d = new ResizeObserver(function(c) {
        k();
      });
      null != document.querySelector(".announcement-bar") && (document.querySelector(".announcement-bar"), d.observe(document.querySelector("#SiteAnnouncement")));
    }
    function u() {
      a.lastScroll = window.scrollY;
      if (window.scrollY >= (30 < v ? v : 30)) {
        if (!a.stickyActive) {
          a.stickyActive = !0;
          a.wrapperOverlayed && a.stickyEnabled && r.classList.remove(a.overlayedClass);
          e();
          var d = Cookies.get("isBarClosed");
          a.stickyBarEnabled && "true" != d || setTimeout(function() {
            null != C && C.classList.add(a.stickyBarTransitionClass);
            a.dynamicBarEnabled && document.querySelectorAll(".drawer__mobile-nav").forEach(c => {
              c.style.top = a.stickyBarEnabled ? v + "px" : "0px";
            });
          }, 100);
        }
      } else {
        a.stickyActive && (a.stickyActive = !1, null != g && g.classList.remove(a.openTransitionClass), null != C && C.classList.remove(a.stickyBarTransitionClass), null != H && H.classList.remove(a.openTransitionClass), a.stickyBarEnabled && (g.style.top = 0 + B + "px"), a.wrapperOverlayed && r.classList.add(a.overlayedClass), document.querySelectorAll(".drawer__mobile-nav").forEach(c => {
          a.dynamicBarEnabled && (c.style.top = v + "px");
        }), e());
      }
    }
    function G() {
      function d(n) {
        L && q();
        M && I();
        c(n.currentTarget);
      }
      function c(n) {
        n = n.parentNode;
        n.classList.contains(m.hasDropdownClass) && (n.classList.add(m.dropdownActive), L = !0);
        if (!theme.config.isTouch && !K) {
          var t = theme.config.isTouch ? "touchend" : "click";
          K = !0;
          document.documentElement.on(t + a.namespace, function() {
            p();
            document.documentElement.off(t + a.namespace);
            K = !1;
          }.bind(this));
        }
      }
      function l(n, t) {
        n = n.parentNode;
        if (n.classList.contains(m.hasSubDropdownClass) || t) {
          n.classList.add(m.dropdownActive), M = !0;
        }
      }
      function p() {
        q();
        I();
      }
      function q() {
        document.querySelectorAll(h.navItems).forEach(n => {
          n.classList.remove(m.dropdownActive);
        });
      }
      function I() {
        document.querySelectorAll(h.navDropdownLinks).forEach(n => {
          n.parentNode.classList.remove(m.dropdownActive);
        });
      }
      var L = !1, M = !1, K = !1;
      theme.config.isTouch && document.querySelectorAll(h.navLinksWithDropdown).forEach(n => {
        n.on("touchend" + a.namespace, function(t) {
          t.currentTarget.parentNode.classList.contains(m.dropdownActive) ? window.location.replace(t.currentTarget.getAttribute("href")) : (t.preventDefault(), p(), c(t.currentTarget));
        });
      });
      document.querySelectorAll(h.navLinks).forEach(n => {
        n.on("focusin" + a.namespace, d);
        n.on("mouseover" + a.namespace, d);
        n.on("mouseleave" + a.namespace, p);
      });
      document.querySelectorAll(h.navDropdownLinks).forEach(n => {
        if (theme.config.isTouch) {
          n.on("touchend" + a.namespace, function(t) {
            var N = t.currentTarget.parentNode;
            N.classList.contains(m.hasSubDropdownClass) ? N.classList.contains(m.dropdownActive) ? window.location.replace(t.currentTarget.getAttribute("href")) : (t.preventDefault(), I(), l(t.currentTarget)) : window.location.replace(t.currentTarget.getAttribute("href"));
          });
        }
        n.on("focusin" + a.namespace, function(t) {
          I();
          l(t.currentTarget, !0);
        });
      });
    }
    function z() {
      document.querySelectorAll(h.searchBtn).forEach(d => {
        d.addEventListener("click", J);
      });
      document.querySelector(h.closeSearch) && document.querySelectorAll(h.closeSearch).forEach(d => {
        d.addEventListener("click", x);
      });
    }
    function J(d) {
      var c = d.target.closest(".site-nav__link");
      c && "false" == c.dataset.hidden ? c.parentElement.querySelector(".site-header__search-input").focus() : (d.preventDefault(), d.stopImmediatePropagation(), document.querySelector(h.searchContainer).classList.add("is-active"), document.dispatchEvent(new CustomEvent("predictive-search:open", {detail:{context:"header"}, bubbles:!0})), document.documentElement.classList.add("js-drawer-open", "js-drawer-open--search"), D());
    }
    function D() {
      setTimeout(function() {
        window.on("click" + a.namespace, function(d) {
          x(d);
        });
      }, 0);
      window.on("keyup", function(d) {
        27 === d.keyCode && x();
      });
      document.addEventListener("predictive-search:close-all", function() {
        x();
      }, {once:!0});
    }
    function x(d) {
      if (d) {
        d = d.path || d.composedPath && d.composedPath();
        for (var c = 0; c < d.length; c++) {
          if (d[c].classList) {
            if (d[c].classList.contains("site-header__close-btn")) {
              break;
            }
            if (d[c].classList.contains("site-header__search-container")) {
              return;
            }
          }
        }
      }
      document.dispatchEvent(new CustomEvent("predictive-search:close", {bubbles:!0}));
      document.activeElement.blur();
      document.documentElement.classList.add("js-drawer-closing");
      document.documentElement.classList.remove("js-drawer-open", "js-drawer-open--search");
      document.documentElement.querySelectorAll(".site-header__search-input").forEach(p => {
        p.value = "";
      });
      window.setTimeout(function() {
        document.documentElement.classList.remove("js-drawer-closing");
      }.bind(this), 500);
      var l = document.querySelector(h.searchContainer);
      theme.Helpers.prepareTransition(l, function() {
        l.classList.remove("is-active");
      }.bind(this));
      slate.a11y.removeTrapFocus({container:l, namespace:"header_search"});
      slate.a11y.unlockMobileScrolling(a.namespace);
      window.off("keyup" + a.namespace);
      window.off("click" + a.namespace);
    }
    function w() {
      document.querySelectorAll(h.modeBtn).forEach(d => {
        d.addEventListener("click", E);
      });
    }
    function E(d) {
      var c = document.documentElement.getAttribute("data-theme"), l = ".site-header__logo-default", p = ".site-header__logo-white";
      c != d && ("dark" != c ? document.documentElement.setAttribute("data-theme", "dark") : document.documentElement.setAttribute("data-theme", null), document.querySelectorAll(".site-header__logo").forEach(q => {
        "dark" != c ? (l = q.querySelector(".site-header__logo-default"), p = q.querySelector(".site-header__logo-white")) : (l = q.querySelector(".site-header__logo-white"), p = q.querySelector(".site-header__logo-default"));
        l && p && (l.classList.remove("logo--has-inverted"), l.classList.add("logo--inverted"), p.classList.remove("logo--inverted"), p.classList.add("logo--has-inverted"));
      }), c = document.documentElement.getAttribute("data-theme"), Cookies.set("theme-mode", c, {path:"/", expires:200}), Cookies.set("theme-mode-set", "true", {path:"/", expires:200}));
    }
    function y(d) {
      document.querySelectorAll(h.logo).forEach(c => {
        var l = c.clientWidth;
        if (c.closest(".grid__item-header")) {
          var p = c.closest(".grid__item-header").clientWidth;
          l > p ? c.style.maxWidth = p : c.removeAttribute("style");
        }
      });
      document.querySelectorAll(".site-header__logo--width").forEach(c => {
        c.width = c.parentElement.parentElement.offsetWidth;
        c.height = c.naturalHeight / c.naturalWidth * c.width;
      });
    }
    var h = {wrapper:"#HeaderWrapper", siteHeader:"#SiteHeader", searchPage:"#SearchPage", siteAnnouncement:"#SiteAnnouncement", announcementWrapper:"#AnnouncementWrapper", searchBtn:".js-search-header", modeBtn:".js-theme-mode", closeSearch:"[data-search-close]", searchContainer:".site-header__search-container", logo:"#LogoContainer img", navItems:".site-nav__item", navLinks:".site-nav__link", navLinksWithDropdown:".site-nav__link--has-dropdown", navDropdownLinks:".site-nav__dropdown-link--second-level"}, 
    m = {hasDropdownClass:"site-nav--has-dropdown", hasSubDropdownClass:"site-nav__deep-dropdown-trigger", dropdownActive:"is-focused"}, a = {namespace:".siteNav", wrapperOverlayed:!1, overlayedClass:"is-light", overlayEnabledClass:"header-wrapper--overlay", stickyEnabled:!1, stickyOnScroll:!1, stickyActive:!1, sidebar:!1, stickyHeaderWrapper:"StickyHeaderWrap", openTransitionClass:"site-header--opening", lastScroll:0, dynamicBarEnabled:!1, stickyBarEnabled:!1, stickyBarClass:"announcement--stuck", 
    stickyBarTransitionClass:"announcement-bar--opening"}, r, g, H, C, A, v, F, B = 0;
    return {init:function(d) {
      r = document.querySelector(h.wrapper);
      F = Shopify.designMode;
      g = document.querySelector(h.siteHeader);
      H = document.querySelector(h.searchPage);
      C = document.querySelector(h.siteAnnouncement);
      A = document.querySelector(h.announcementWrapper);
      g.classList.contains("site-header-blurred") && (B = 20);
      a.dynamicBarEnabled = A && "true" === A.dataset.dynamic ? !0 : !1;
      a.stickyBarEnabled = A && "true" === A.dataset.sticky ? !0 : !1;
      a.stickyEnabled = !g || "sticky" !== g.dataset.sticky && "sticky_scroll" !== g.dataset.sticky ? !1 : !0;
      a.stickyOnScroll = g && "sticky_scroll" === g.dataset.sticky ? !0 : !1;
      a.wrapperOverlayed = r ? r.classList.contains(a.overlayedClass) : !1;
      a.sidebar = g && g.classList.contains("site-header--sidebar") ? !0 : !1;
      a.stickyEnabled && g.classList.add("site-header--sticky");
      if (g) {
        a.sidebar && (this.mobileNav = new theme.MobileNav({id:"SidebarNav", inHeader:!0}));
        b();
        theme.settings.overlayHeader = "true" === g.dataset.overlay;
        G();
        z();
        var c = "true" === g.dataset.darkmode, l = Cookies.get("theme-mode-set");
        if (c) {
          if ("true" != l && (c = g.dataset.sunrise, l = g.dataset.sunset, c && (new Date()).getHours() >= parseInt(c) && E(), l)) {
            let q = (new Date()).getHours();
            (q >= parseInt(l) || q < c) && E("dark");
          }
          w();
        }
        window.on("load" + a.namespace, y);
        var p = window.innerWidth;
        window.on("resize" + a.namespace, theme.Helpers.debounce(150, function() {
          window.innerWidth != p && (p = window.innerWidth, y());
        }.bind(this)));
        window.on("load" + a.namespace, e);
        window.on("resize" + this.namespace, function() {
          window.innerWidth != p && (p = window.innerWidth, e());
        });
        window.on("load" + a.namespace, k);
        17 < window.scrollY && r.classList.remove(a.overlayedClass);
        "header" == d && a.stickyOnScroll && (this.prevScrollpos = window.pageYOffset, window.on("scroll" + a.namespace, function(q) {
          u();
          q = window.pageYOffset;
          this.prevScrollpos > q ? (document.querySelector("#SiteHeader").style.transitionDuration = "0.15s", document.querySelector("#SiteHeader").style.transform = "translateY(0%)") : q > document.querySelector("#SiteHeader").offsetHeight && (document.querySelector("#SiteHeader").style.transitionDuration = "0.15s", document.querySelector("#SiteHeader").style.transform = "translateY(-100%)");
          this.prevScrollpos = q;
        }.bind(this)));
        Shopify.designMode && document.addEventListener("shopify:section:load", function(q) {
          y();
          e();
          k();
        });
      }
    }, resizeHeader:k};
  }();
  theme.SearchPage = function() {
    function k(e) {
      this.container = e;
      this.containerId = e.id;
      this.sectionId = e.getAttribute("data-section-id");
      this.init(e);
    }
    k.prototype = Object.assign({}, k.prototype, {init:function(e) {
      e || (this.container = document.getElementById(this.containerId));
      this.initGridOptions();
      this.resize();
    }, initGridOptions:function() {
      var e = this.container.querySelector(".product-grid"), b = this.container.querySelectorAll(".grid-view-btn");
      this.container.querySelectorAll(".grid-view-btn").forEach(f => {
        f.addEventListener("click", function() {
          b.forEach(G => {
            G.classList.remove("is-active");
          });
          f.classList.add("is-active");
          var u = f.dataset.view;
          e.dataset.view = u;
          theme.cart.updateAttribute("product_view", u);
          window.dispatchEvent(new Event("resize"));
        });
      });
    }, resize:function() {
      var e = document.querySelector("#SiteAnnouncement"), b = document.querySelector("#SiteHeader").scrollHeight, f = 0;
      null != e && (f = e.offsetHeight);
      document.getElementById("SearchPage").style.height = b + "px";
      document.getElementById("SearchPageForm").style.height = b + "px";
      document.getElementById("SearchPage").style.transform = "translate3d(0px," + f + "px, 0)";
      setTimeout(function() {
        document.getElementById("SearchPage").style.transition = "transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)";
      }, 100);
    }});
    return k;
  }();
  theme.PredictiveSearch = function() {
    function k(e) {
      this.enabled = !0;
      this.container = e;
      this.context = this.container.getAttribute("data-context");
      this.input = this.container.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.container.querySelector("[data-predictive-search]");
      this.closeBtn = this.container.querySelector(".btn--close-search");
      this.screen = this.container.querySelector("[data-screen]");
      this.SearchModal = this.container.closest("#SearchModal") || null;
      this.isBoxed = (this.siteHeader = document.querySelector("#SiteHeader") || null) && this.siteHeader.classList.contains("site-header-blurred") ? !0 : !1;
      document.addEventListener("predictive-search:open", b => {
        b.detail.context === this.context && (this.container.classList.add("is-active"), setTimeout(() => {
          this.input.focus();
        }, 500));
      });
      this.SearchModal && (new MutationObserver(b => {
        b.forEach(f => {
          "class" === f.attributeName && -1 < f.target.className.indexOf("modal--is-active") && setTimeout(() => {
            this.input.focus();
          }, 500);
        });
      })).observe(this.SearchModal, {attributes:!0});
      "false" !== this.enabled && (this.input.addEventListener("keydown", () => {
        this.container.classList.add("is-active");
      }), this.input.addEventListener("input", this.debounce(b => {
        this.onChange(b);
      }, 300).bind(this)), document.addEventListener("predictive-search:close", () => {
        this.close();
      }), document.addEventListener("keydown", b => {
        27 === b.keyCode && this.close();
      }), this.closeBtn.addEventListener("click", b => {
        b.preventDefault();
        this.close();
      }), this.screen.addEventListener("click", () => {
        this.close();
      }));
    }
    k.prototype = Object.assign({}, k.prototype, {init:function() {
    }, onChange:function() {
      const e = this.input.value.trim();
      e.length ? this.getSearchResults(e) : this.close();
    }, getSearchResults:function(e) {
      e = this.paramUrl({q:e, "resources[limit]":6, "resources[limit_scope]":"each", "resources[options][unavailable_products]":"last"});
      fetch(`${theme.routes.predictiveSearch}?${e}&section_id=search-results`).then(b => {
        if (!b.ok) {
          throw b = Error(b.status), this.close(), b;
        }
        return b.text();
      }).then(b => {
        b = (new DOMParser()).parseFromString(b, "text/html").querySelector("#shopify-section-search-results").innerHTML;
        this.predictiveSearchResults.innerHTML = b;
        this.open();
      }).catch(b => {
        this.close();
        throw b;
      });
    }, open:function() {
      var e = document.querySelector("#SiteAnnouncement") ? document.querySelector("#SiteAnnouncement").offsetHeight : 0;
      this.predictiveSearchResults.style.display = "block";
      document.body.classList.add("predictive-overflow-hidden");
      this.siteHeader && "true" == this.siteHeader.dataset.overlay && this.siteHeader.classList.add("active_search--background");
      this.predictiveSearchResults.classList.add("is-active");
      document.querySelectorAll(".search__results").forEach(b => {
        var f = 0;
        console.log("this.isBoxedthis.isBoxed:", this.isBoxed);
        this.isBoxed && (f = 115);
        b.style.height = "calc(100vh - " + (b.offsetTop + e + f) + "px)";
      });
      this.lockScrolling();
    }, close:function() {
      this.unlockScrolling();
      this.predictiveSearchResults.classList.remove("is-active");
      this.predictiveSearchResults.style.display = "none";
      this.predictiveSearchResults.innerHTML = "";
      this.container.classList.remove("is-active");
      document.body.classList.remove("predictive-overflow-hidden");
      document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
      this.siteHeader && this.siteHeader.classList.remove("active_search--background");
    }, lockScrolling:function() {
      var e = document.querySelector(".btn--back-to-top");
      e && (e.style.zIndex = 0);
      document.documentElement.classList.add("lock-scroll");
      document.documentElement.classList.add("js-search-open");
      document.documentElement.on("touchmove", function() {
        return !0;
      });
    }, unlockScrolling:function() {
      var e = document.querySelector(".btn--back-to-top");
      e && (e.style.zIndex = 150);
      document.documentElement.classList.remove("lock-scroll");
      document.documentElement.classList.remove("js-search-open");
      document.documentElement.off("touchmove");
    }, debounce:function(e, b) {
      let f;
      return (...u) => {
        clearTimeout(f);
        f = setTimeout(() => e.apply(this.container, u), b);
      };
    }, paramUrl:function(e) {
      return Object.keys(e).map(function(b) {
        return b + "=" + encodeURIComponent(e[b]);
      }).join("&");
    }});
    return k;
  }();
  theme.UpsellSlider = function() {
    function k(b) {
      this.container = b;
      var f = b.getAttribute("data-section-id");
      this.slideshow = b.querySelector(".upsellproducts-" + f);
      this.namespace = ".upsellproduct-" + f;
      this.slideshow && theme.initWhenVisible({element:this.container, callback:this.init.bind(this), threshold:600});
    }
    var e = {adaptiveHeight:!1, avoidReflow:!0, pageDots:!1, autoPlay:!0, pauseAutoPlayOnHover:!0, prevNextButtons:!0};
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      e.wrapAround = !0;
      590 > (window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth) && (e.prevNextButtons = !1);
      this.flickity = new theme.Slideshow(this.slideshow, e);
      1 < this.slideshow.dataset.count && setTimeout(function() {
        this.flickity.goToSlide(1);
      }.bind(this), 200);
    }});
    return k;
  }();
  (function(k) {
    "loading" != document.readyState ? k() : document.addEventListener("DOMContentLoaded", k);
  })(function() {
    theme.sections.register("header-section", theme.HeaderSection);
    theme.sections.register("predictive-search", theme.PredictiveSearch);
    theme.sections.register("cart-template", theme.Cart);
    theme.sections.register("searchpage-template", theme.SearchPage);
    theme.sections.register("upsell-slider", theme.UpsellSlider);
  });
})();